module.exports = __webpack_public_path__ + "static/media/logoPost.3d694d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/dif/media/logoPost.png
// module id = 868
// module chunks = 0